import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { FaRedo, FaTimes } from "react-icons/fa";
import styled from "styled-components";

const IconeContainer = styled.div`
  padding: 0.75rem 1rem;
  background-color: #fde8e8;
  border-radius: 0.5rem;
  svg {
    color: #dc3545;
  }
`;

const InfoContainer = styled.div`
  display: grid;
  place-items: center;
  gap: 1rem;
  padding: 1rem;
`;

const TextContainer = styled.div`
  text-align: center;
`;

interface Props {
  show: boolean;
  handleClose: () => void;
  onReprocessar: () => void;
  descricaoErro: string;
}

export function ModalErroBloqueio({ show, handleClose, onReprocessar, descricaoErro }: Props) {
  return (
    <ModalCustom show={show} handleClose={handleClose} title="Erro - Bloqueio" centered>
      <InfoContainer>
        <IconeContainer>
          <FaTimes />
        </IconeContainer>
        <TextContainer>{descricaoErro}</TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-between gap-4 mt-4">
        <PrimaryButton style={{ width: "14rem" }} outline variante="primary" onClick={handleClose}>
          OK
        </PrimaryButton>
        <PrimaryButton style={{ width: "14rem" }} onClick={onReprocessar}>
          Reprocessar <FaRedo />
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
